module.exports = __webpack_public_path__ + "img/daten-icon-light.a357582e.svg";